import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Autocomplete, SxProps, TextField } from '@mui/material';
import { Oem } from '../../../types/Oem';
import ApiService from '../../../ApiService';
import { OemCriteria } from '../../../types/Criteria/OemCriteria';

interface OemAutocompleteProps {
    value: number | number[] | null;
    onChange: (value: Oem | Oem[] | null) => void;
    multiple?: boolean;
    disabled?: boolean;
    sx?: SxProps;
    label?: string;
    criteria?: OemCriteria;
}

const OemAutocomplete: FC<OemAutocompleteProps> = ({
    value,
    onChange,
    label = 'Select OEM',
    multiple = false,
    disabled = false,
    sx = {},
    criteria = {},
}) => {
    const { data } = useQuery({
        queryKey: ['oems', criteria],
        queryFn: async () => {
            const { data } = await ApiService.getOems(criteria, { page: 0, size: -1 });
            return data;
        },
        enabled: true,
    });

    const selectedOptions =
        data?.filter((oem) => (Array.isArray(value) ? value.some((v) => v === oem.id) : value === oem.id)) || [];

    return (
        <Autocomplete
            size="small"
            multiple={multiple}
            disabled={disabled}
            value={selectedOptions}
            onChange={(_, newValue) => onChange(newValue)}
            options={data || []}
            sx={sx}
            getOptionLabel={(option: Oem) => option.name}
            isOptionEqualToValue={(option: Oem, value: Oem) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label={label} />}
        />
    );
};

export default OemAutocomplete;
